import React from "react";
import OpenBankingLoadingView from "./OpenBankingLoadingView";
import * as PropTypes from "prop-types";

export default function OpenBankingLoadingPage({ state, productRedirectUrl }) {
  return (
    <OpenBankingLoadingView
      state={state}
      productRedirectUrl={productRedirectUrl}
    />
  );
}

OpenBankingLoadingPage.propTypes = {
  state: PropTypes.string,
  productRedirectUrl: PropTypes.string,
};
